import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56f782d8")

_pushScopeId("data-v-56f782d8")
const _hoisted_1 = { class: "card mt-5 genealogy-table-card" }
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = { class: "card-title m-0 flex-column align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Member List", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-7 mt-1"
}
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-3 genealogy-table" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-80px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-250px" }, "Member"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-120px text-center" }, "Left"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-120px text-center" }, "Right"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-250px rounded-end" }, "Sponsor")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("td", {
  colspan: "5",
  class: "text-center text-muted py-10"
}, "No members found in this genealogy tree.", -1)
const _hoisted_12 = { class: "ps-4" }
const _hoisted_13 = { class: "genealogy-table-position-badge" }
const _hoisted_14 = { class: "genealogy-table-member" }
const _hoisted_15 = { class: "genealogy-table-fullname" }
const _hoisted_16 = { class: "genealogy-table-usid" }
const _hoisted_17 = {
  key: 0,
  class: "genealogy-table-badges"
}
const _hoisted_18 = {
  key: 0,
  class: "genealogy-table-status genealogy-table-status--pps"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "genealogy-table-count" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "genealogy-table-count" }
const _hoisted_23 = {
  key: 0,
  class: "genealogy-table-member genealogy-table-member--sponsor"
}
const _hoisted_24 = { class: "genealogy-table-fullname" }
const _hoisted_25 = { class: "genealogy-table-usid" }
const _hoisted_26 = {
  key: 1,
  class: "text-muted fs-7"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.data.length)
          ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.data.length) + " members in this tree", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("table", _hoisted_8, [
          _hoisted_9,
          _createVNode("tbody", null, [
            (_ctx.data.length === 0)
              ? (_openBlock(), _createBlock("tr", _hoisted_10, [
                  _hoisted_11
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
              return (_openBlock(), _createBlock("tr", {
                key: index,
                class: ["genealogy-table-row", { 'genealogy-table-row--pps': item.isPPS === 1 }],
                onClick: ($event: any) => (_ctx.navigateToUser(item.usid))
              }, [
                _createVNode("td", _hoisted_12, [
                  _createVNode("span", _hoisted_13, _toDisplayString(item.positionNo), 1)
                ]),
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.capitalizeName(item.fullname)), 1),
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.formatUsid(item.usid)), 1),
                    (item.isPPS === 1 || item.packagetypeDesc)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          (item.isPPS === 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_18, "PPS"))
                            : _createCommentVNode("", true),
                          (item.packagetypeDesc)
                            ? (_openBlock(), _createBlock("span", {
                                key: 1,
                                class: ["genealogy-table-status", _ctx.isPpsPackageType(item.packagetypeDesc) ? 'genealogy-table-status--pps-package' : 'genealogy-table-status--package']
                              }, _toDisplayString(item.packagetypeDesc), 3))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("td", _hoisted_19, [
                  _createVNode("span", _hoisted_20, _toDisplayString(item.lltd), 1)
                ]),
                _createVNode("td", _hoisted_21, [
                  _createVNode("span", _hoisted_22, _toDisplayString(item.rltd), 1)
                ]),
                _createVNode("td", null, [
                  (item.spid)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _createVNode("span", _hoisted_24, _toDisplayString(_ctx.capitalizeName(item.sponsorfullname)), 1),
                        _createVNode("span", _hoisted_25, _toDisplayString(_ctx.formatUsid(item.spid)), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_26, "—"))
                ])
              ], 10, ["onClick"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
})